import React from 'react';
import './RelayOverview.css';

const RelayOverview = () => {
    // Dummy Data
    const metrics = {
        totalTransformations: 12,
        activeProxies: 3,
        totalRequests: 15420,
        avgResponseTime: '124ms'
    };

    const transformationUsage = [
        { id: 1, name: 'SAP to JSON', calls: 5432, lastUsed: '2 mins ago', status: 'active' },
        { id: 2, name: 'XML to EDI', calls: 3210, lastUsed: '15 mins ago', status: 'active' },
        { id: 3, name: 'CSV to JSON', calls: 1205, lastUsed: '1 hour ago', status: 'inactive' },
        { id: 4, name: 'Custom Map A', calls: 890, lastUsed: '3 hours ago', status: 'active' },
        { id: 5, name: 'Legacy Format', calls: 120, lastUsed: '1 day ago', status: 'deprecated' },
    ];

    const proxyUsage = [
        { id: 1, name: 'Partner A Proxy', endpoint: '/api/v1/titan/serials/request/partnerA', calls: 8500, errors: 12 },
        { id: 2, name: 'Partner B Proxy', endpoint: '/api/v1/titan/serials/request/partnerB', calls: 4200, errors: 5 },
        { id: 3, name: 'Test Proxy', endpoint: '/api/v1/titan/serials/request/test', calls: 2720, errors: 0 },
    ];

    return (
        <>
            <header className="top-header">
                <div className="breadcrumb">
                    <span>Relay</span>
                    <span className="breadcrumb-separator">/</span>
                    <span className="breadcrumb-current">Overview</span>
                </div>
            </header>
            <div className="relay-overview">
                <header className="page-header">
                    <h1>Relay Overview</h1>
                    <p className="subtitle">Monitor transformations and API proxy usage</p>
                </header>

                {/* Top Metrics Cards */}
                <div className="metrics-grid">
                    <div className="metric-card">
                        <div className="metric-title">Total Transformations</div>
                        <div className="metric-value">{metrics.totalTransformations}</div>
                        <div className="metric-change positive">+2 this week</div>
                    </div>
                    <div className="metric-card">
                        <div className="metric-title">Active Proxies</div>
                        <div className="metric-value">{metrics.activeProxies}</div>
                        <div className="metric-status">All Systems Operational</div>
                    </div>
                    <div className="metric-card">
                        <div className="metric-title">Total Requests (24h)</div>
                        <div className="metric-value">{metrics.totalRequests.toLocaleString()}</div>
                        <div className="metric-change positive">↑ 12%</div>
                    </div>
                    <div className="metric-card">
                        <div className="metric-title">Avg Response Time</div>
                        <div className="metric-value">{metrics.avgResponseTime}</div>
                        <div className="metric-change negative">↓ 5ms</div>
                    </div>
                </div>

                <div className="content-grid">
                    {/* Transformation Usage Section */}
                    <div className="content-section">
                        <div className="section-header">
                            <h2>Transformation Usage</h2>
                        </div>
                        <div className="table-container">
                            <table className="data-table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Calls (24h)</th>
                                        <th>Last Used</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {transformationUsage.map((item) => (
                                        <tr key={item.id}>
                                            <td className="font-medium">{item.name}</td>
                                            <td>{item.calls.toLocaleString()}</td>
                                            <td className="text-muted">{item.lastUsed}</td>
                                            <td>
                                                <span className={`status-badge ${item.status}`}>
                                                    {item.status}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* API Proxy Usage Section */}
                    <div className="content-section">
                        <div className="section-header">
                            <h2>API Proxy Usage</h2>
                        </div>
                        <div className="table-container">
                            <table className="data-table">
                                <thead>
                                    <tr>
                                        <th>Proxy Name</th>
                                        <th>Endpoint</th>
                                        <th>Calls</th>
                                        <th>Errors</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {proxyUsage.map((item) => (
                                        <tr key={item.id}>
                                            <td className="font-medium">{item.name}</td>
                                            <td className="code-text">{item.endpoint}</td>
                                            <td>{item.calls.toLocaleString()}</td>
                                            <td>
                                                <span className={`error-count ${item.errors > 0 ? 'has-errors' : ''}`}>
                                                    {item.errors}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RelayOverview;
